import { ICountryDetails } from '../interfaces/country-details.interface';

import { InitializeField } from './initialize-field.model';

export class CountryDetails
  extends InitializeField<ICountryDetails>
  implements ICountryDetails
{
  place_id: string = '';
  name: string = '';

  description: string = '';
  shortDescription: string = '';
  extraDescription: string = '';
  thingsToDoExtraDescription?: string = '';
  thingsToDoShortDescription?: string = '';
  thingsToDoLongDescription?: string = '';

  coordinates: string = '';
  link: string = '';
  slug: string = '';
  country_id: string = '';
  type: string = '';
  countryCode: string = '';

  wikiLink: string = '';
  wikiImg?: string = '';

  imageUrl: string = '';
  imageTitle: string = '';
  imageLicense: string = '';
  imageOwner: string = '';
  imageOwnerUrl: string = '';
  imageSource: string = '';

  warning?: string = '';

  protected excludedKeys: string[] = [];

  get thingsTodoDescription(): string {
    return (
      this.thingsToDoExtraDescription ||
      this.thingsToDoShortDescription ||
      this.thingsToDoLongDescription ||
      this.shortDescription ||
      this.description
    );
  }

  constructor(data: Partial<ICountryDetails> = {}) {
    super();
    this.initializeFields(data);
  }

  public exist(): boolean {
    return !!this.place_id;
  }

  protected getDefaultValue(key: string): any {
    switch (key) {
      case 'place_id':
      case 'name':
      case 'description':
      case 'shortDescription':
      case 'extraDescription':
      case 'thingsToDoExtraDescription':
      case 'thingsToDoShortDescription':
      case 'thingsToDoLongDescription':
      case 'coordinates':
      case 'link':
      case 'type':
      case 'wikiLink':
        return '';

      case 'slug':
      case 'country_id':
      case 'countryCode':
      case 'warning':
        return null;

      case 'imageUrl':
      case 'imageTitle':
      case 'imageLicense':
      case 'imageOwner':
      case 'imageOwnerUrl':
      case 'imageSource':
      case 'wikiImg':
        return '';

      default:
        return null;
    }
  }
}
